import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
import { PortalGlobals } from '../../../../../portalglobals'
import { LengthTextFieldValidator } from '../../../../../validations/length-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { EnrollmentCacheData } from '../../../../models/EnrollmentCacheData'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { GetEnrollmentDataResponse } from '../../../../models/get-enrollment-data-response'
import { Notes } from '../../../../models/notes'
import { AccountTypes, PaymentAccount } from '../../../../models/payment-account'
import { SubmitEnrollmentDataResponse } from '../../../../models/submit-enrollment-data-response'
import * as moment from 'moment'

@Component({
    selector: 'PhoneEnrollmentSpanishStep3',
    templateUrl: 'phone-enrollment-step3.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentSpanishStep3Component implements OnInit {
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    @Input() paymentAccount: PaymentAccount = {} as PaymentAccount
    // @Output() onPaymentAccountChange: EventEmitter<PaymentAccount> = new EventEmitter<PaymentAccount>()
    //  @Output() onPaymentOptionChange: EventEmitter<string> = new EventEmitter<string>()
    routingNumberLengthValidator: LengthTextFieldValidator = new LengthTextFieldValidator(9)
    notBlankValidator: NotBlankGenericFieldValidator = new NotBlankGenericFieldValidator()
    numericValidator: NumericTextFieldValidator = new NumericTextFieldValidator()
    @Input() disabled: boolean = false
    @Input() paymentOption: string = ''
    ShowCurrentYearScript: boolean = false

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    notesModel = {} as Notes
    public IsAutomatciSocial: boolean
    public IsAUTOMATIC_RAILROAD: boolean
    public IsElectronicFund: boolean
    public IsMonthly: boolean
    public IsRblLISYes: boolean
    public IsRblLISNo: boolean
    public rblLIS: ValidatedRadioButtonModel[] = []
    public accountTypeNewOptions: ValidatedRadioButtonModel[] = []
    hasError: boolean
    IsSelectPlan: boolean
    ErrorMessages: any[]
    currentdate: string
    insuranceComapny: string
    public loading: boolean = false
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyourhisher: string
    spnYourBeneficiaryNew: string
    spnYouenrollee: string
    spnYourenrollee: string
    spnyouhisher: string
    spnauthorize: string
    spndodoes: string
    spnyouenrollee: string
    AgentFullName: string
    checkPlanyear: boolean = true
    IsShowScript: boolean = false
    accountInfoFormIsVisible() {
        return this.paymentOption === 'ELECTRONIC_FUND_TRANSFER'
    }
    accountTypeOptions: ValidatedRadioButtonModel[] = Object.keys(AccountTypes).map((accountTypeKey) => {
        return { value: accountTypeKey, htmlLabel: AccountTypes[accountTypeKey] }
    })
    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private router: Router,
        public _global: PortalGlobals,
        private _currentUserGateway: CurrentUserGateway
    ) {
        this.rblLIS.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.accountTypeNewOptions.push({ value: 'CHECKING', htmlLabel: 'Cuenta corriente' }, { value: 'SAVINGS', htmlLabel: 'Caja de ahorro' })
        this.IsAutomatciSocial = false
        this.IsAUTOMATIC_RAILROAD = false
        this.IsElectronicFund = false
        this.IsMonthly = false
        this.IsRblLISYes = false
        this.IsRblLISNo = false
        this.IsSelectPlan = false
        this.IsShowScript = false
        this.currentdate = moment().format('MM/DD/YYYY')

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        } else {
            this.ShowCurrentYearScript = false
        }
    }
    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)
        if (this.enrollment === null || this.enrollment === undefined) {
            this.router.navigate([
                '/' +
                    insCo +
                    '/enrollment/phone-enrollment/spanish/Step1/' +
                    this.enrollmentCacheData.CALLOGID +
                    '/' +
                    this.enrollmentCacheData.PlanYear
            ])
        }
        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                        this.enrollment.CALLOGID = this.enrollmentCacheData.CALLOGID
                        this.enrollment.RBLBENFE = this.enrollmentCacheData.RBLBENFE

                        this.LoadData()
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate([
                    '/' + insCo + '/enrollment/phone-enrollment/spanish/Step1/' + this.enrollment.CALLOGID + '/' + this.enrollment.PLANYEAR
                ])
            }
        } else {
            this.LoadData()
        }
    }

    LoadData(): void {
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }

        if (this._global.currentUser !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.AgentFullName =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)

        this.setScript()
        this.paymentOptions = [
            {
                value: 'Direct Bill',
                htmlLabel: 'recibir la factura por correo postal y pagar con cheque o adherir a un pago automático mediante tarjeta de crédito;',
                disabled: this.disabled
            },
            {
                value: 'Automatic Bank Draft Withdrawal',
                htmlLabel:
                    'deducción automática de su cuenta corriente o caja de ahorro. ' +
                    this.spnYouenrollee +
                    ' puede inscribirse en esta opción hoy durante la llamada;',
                disabled: this.disabled
            },
            {
                value: 'Deduction from Social Security Check',
                htmlLabel:
                    'deducción automática de su beneficio mensual del Seguro Social . ' +
                    this.spnYouenrollee +
                    ' puede inscribirse en esta opción hoy durante la llamada.',
                disabled: this.disabled
            },
            {
                value: 'Deduction from Railroad Retirement Board',
                htmlLabel:
                    'deducción automática de su beneficio mensual del  o  beneficio de Retiro Ferroviario. ' +
                    this.spnYouenrollee +
                    ' puede inscribirse en esta opción hoy durante la llamada.',
                disabled: this.disabled
            }
        ]
        if (this.ShowCurrentYearScript) {
            this.paymentOptions = [
                {
                    value: 'Direct Bill',
                    htmlLabel: 'recibir la factura por correo postal y pagar con cheque o adherir a un pago automático mediante tarjeta de crédito;',
                    disabled: this.disabled
                },
                {
                    value: 'Automatic Bank Draft Withdrawal',
                    htmlLabel:
                        'deducción automática de su cuenta corriente o caja de ahorro. ' +
                        this.spnYouenrollee +
                        ' puede inscribirse en esta opción hoy durante la llamada;',
                    disabled: this.disabled
                },
                {
                    value: 'Deduction from Social Security Check',
                    htmlLabel:
                        'deducción automática de su beneficio mensual del Seguro Social . ' +
                        this.spnYouenrollee +
                        ' puede inscribirse en esta opción hoy durante la llamada.',
                    disabled: this.disabled
                },
                {
                    value: 'Deduction from Railroad Retirement Board',
                    htmlLabel:
                        'deducción automática de su beneficio mensual del  o  beneficio de Retiro Ferroviario. ' +
                        this.spnYouenrollee +
                        ' puede inscribirse en esta opción hoy durante la llamada.',
                    disabled: this.disabled
                }
            ]
        } else {
            this.paymentOptions = [
                {
                    value: 'Direct Bill',
                    htmlLabel:
                        'recepción de la factura por correo postal y pago con cheque o adhesión a un pago automático mediante tarjeta de crédito;',
                    disabled: this.disabled
                },
                {
                    value: 'Automatic Bank Draft Withdrawal',
                    htmlLabel:
                        'deducción automática de su cuenta corriente o caja de ahorro. ' +
                        this.spnYouenrollee +
                        ' puede inscribirse en esta opción hoy durante la llamada;',
                    disabled: this.disabled
                },
                {
                    value: 'Deduction from Social Security Check',
                    htmlLabel:
                        'deducción automática de su beneficio mensual del Seguro Social . ' +
                        this.spnYouenrollee +
                        ' puede inscribirse en esta opción hoy durante la llamada.',
                    disabled: this.disabled
                },
                {
                    value: 'Deduction from Railroad Retirement Board',
                    htmlLabel:
                        'deducción automática de su beneficio mensual del  o  beneficio de Retiro Ferroviario. ' +
                        this.spnYouenrollee +
                        ' puede inscribirse en esta opción hoy durante la llamada.',
                    disabled: this.disabled
                }
            ]
        }
        this.paymentOptionChanged(this.enrollment.paymentOption)
        this.ShowOptionsRblLIS(this.enrollment.RBLLIS)
    }
    validateForm(): boolean {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        if (this.enrollment.PWO === undefined || this.enrollment.PWO === '' || this.enrollment.PWO === null) {
            this.ErrorMessages.push('Tipo de pago es requerido')
            this.hasError = true
        }
        if (this.enrollment.PWO === 'Automatic Bank Draft Withdrawal') {
            if (this.enrollment.ACCHOLDERNAME === undefined || this.enrollment.ACCHOLDERNAME === '') {
                this.ErrorMessages.push('Por favor ingrese un nombre de cuenta válido')
                this.hasError = true
            }
            if (this.enrollment.ACCHOLDERNAME !== undefined && this.enrollment.ACCHOLDERNAME !== '' && this.enrollment.ACCHOLDERNAME !== null) {
                let checkACCHOLDERNAME = this.enrollment.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('El nombre de la cuenta bancaria no es válido')
                }
            }
            if (this.enrollment.EFTTYPE === undefined || this.enrollment.EFTTYPE === '') {
                this.ErrorMessages.push('Seleccione tipo de cuenta')
                this.hasError = true
            }
            if (this.enrollment.FININSTNAME === undefined || this.enrollment.FININSTNAME === '') {
                this.ErrorMessages.push('Por favor ingrese una institución financiera válida')
                this.hasError = true
            }
            if (this.enrollment.FININSTNAME !== undefined && this.enrollment.FININSTNAME !== '' && this.enrollment.FININSTNAME !== null) {
                let checkFININSTNAME = this.enrollment.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('La institución financiera en la cuenta bancaria no es válida')
                }
            }
            if (this.enrollment.ROUTINGNB === undefined || this.enrollment.ROUTINGNB === '') {
                this.ErrorMessages.push('Ingrese un número de ruta válido')
                this.hasError = true
            }
            if (this.enrollment.ROUTINGNB !== undefined && this.enrollment.ROUTINGNB !== '' && this.enrollment.ROUTINGNB !== null) {
                let checkROUTINGNB = this.enrollment.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('El número de ruta no es válido')
                }
            }
            if (this.enrollment.ROUTINGNB !== undefined && this.enrollment.ROUTINGNB !== '' && this.enrollment.ROUTINGNB !== null) {
                if (this.enrollment.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('El número de ruta debe ser 9 números')
                }
            }

            if (this.enrollment.ACCOUNTNB === undefined || this.enrollment.ACCOUNTNB === '') {
                this.ErrorMessages.push('Por favor ingrese un número de cuenta válido')
                this.hasError = true
            }
            if (this.enrollment.ACCOUNTNB !== undefined && this.enrollment.ACCOUNTNB !== '' && this.enrollment.ACCOUNTNB !== null) {
                let checkACCOUNTNB = this.enrollment.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('El número de cuenta no es válido')
                }
            }
        }
        //if (this.enrollment.RBLLIS === undefined || this.enrollment.RBLLIS === '' || this.enrollment.RBLLIS === null) {
        //    this.hasError = true
        //    this.ErrorMessages.push('Please select LIS option')
        //}

        return this.hasError
    }
    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/Step2'])
    }
    formSubmit(): void {
        this.ErrorMessages = [] as any[]
        this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollment.STEPCODE = '33'
        if (this.enrollment.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        if (!this.validateForm()) {
            this.loading = true
            this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = false

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                            this.loading = false
                        } else {
                            if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                                this.enrollment.ENROLLKEY = response.EnrollmentKey
                                this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                this.loading = false
                                this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/Step4'])
                            } else {
                                this.ErrorMessages.push('Error while submitting data, please try again.')
                                this.loading = false
                                this.hasError = true
                            }
                            this.loading = false
                        }
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                        this.loading = false
                    }
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }
    //paymentFormChange(paymentAccount: PaymentAccount) {
    //    this.paymentAccount = paymentAccount
    //    this.onPaymentAccountChange.emit(paymentAccount)
    //}

    paymentOptionChanged(option: string) {
        this.enrollment.PWO = option
        // this.onPaymentOptionChange.emit(option)
        if (option === 'Deduction from Social Security Check') {
            this.IsAutomatciSocial = true
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.IsSelectPlan = false
            this.IsShowScript = true
        }
        if (option === 'Deduction from Railroad Retirement Board') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = true
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.IsSelectPlan = false
            this.IsShowScript = true
        }
        if (option === 'Automatic Bank Draft Withdrawal') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = true
            this.IsMonthly = false
            this.IsSelectPlan = false
            this.IsShowScript = true
        }
        if (option === 'Direct Bill') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = true
            this.IsSelectPlan = false
            this.IsShowScript = true
        }
        this.enrollment.paymentOption = option
    }
    resetBankDeatils() {
        this.enrollment.ACCHOLDERNAME = ''
        this.enrollment.EFTTYPE = ''
        this.enrollment.FININSTNAME = ''
        this.enrollment.ROUTINGNB = ''
        this.enrollment.ACCOUNTNB = ''

        this.paymentAccount.holderName = ''
        this.paymentAccount.institution = ''
        this.paymentAccount.number = ''
        this.paymentAccount.routingNumber = ''
        this.paymentAccount.type = null
        this.paymentAccount = {} as PaymentAccount
        this.enrollment.paymentAccount = this.paymentAccount
    }
    ShowOptionsRblLIS(val: any) {
        if (val === 'Yes') {
            this.IsRblLISYes = true
            this.IsRblLISNo = false
        }
        if (val === 'No') {
            this.IsRblLISYes = false
            this.IsRblLISNo = true
        }
        this.enrollment.RBLLIS = val
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'usted'
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyourhisher = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnYouenrollee = 'Usted'
            this.spnYourenrollee = 'Your'
            this.spnyouhisher = 'you'
            this.spnauthorize = 'authorize'
            this.spndodoes = 'do'
            this.spnyouenrollee = 'usted'
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== '' &&
            this.AgentFullName !== 'undefined undefined'
        ) {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnYouenrollee = 'La persona inscripta'
            this.spnYourenrollee = 'enrollee’s'
            this.spnauthorize = 'authorizes'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spndodoes = 'does'
            this.spnyouenrollee = 'la persona inscrita'
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhisher = 'his'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhisher = 'her'
            } else {
                this.spnyouheshe = '(he, she)'
                this.spnyourhisher = '(his, her)'
                this.spnyouhisher = '(his, her)'
            }
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiary = '(usted/nombre de la persona inscripta)'
            this.spnIsAre = '(are, is)'
            this.spnYourMediBeneficiary = '(your/the Medicare Beneficiary’s)'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = '(your, enrollee’s)'
            this.spnIsQualify = '(qualify, qualifies) '
            this.spnYouThey = '(you, they) '
            this.spnYourTheir = '(your, their) '
            this.spnHasHave = '(have, has)'
            this.spnIsReside = '(s)'
            this.spnyouheshe = '(you, he, she)'
            this.spnyourhisher = '(your, his, her)'
            this.spnYourBeneficiaryNew = '(your/Medicare beneficiary)'
            this.spnYouenrollee = 'La persona inscripta'
            this.spnYourenrollee = '(Your, enrollee’s)'
            this.spnyouhisher = '(you, his, her)'
            this.spnauthorize = 'authorize'
            this.spndodoes = '(do, does)'
            this.spnyouenrollee = 'la persona inscrita'
        }
    }
}
